//todo: layout width might not change displayWidth
//todo: dynamic images
//todo: stop computer and all else when not show
//import CardUI from "CardUI.js" //needs  <script type="module" src="..."> as entry point
import { Scene, Loader } from 'phaser';
import CardUI from "./CardUI.js";
import ButtonSolid from "./ButtonSolid.js";
export default class SpeedUI extends Scene {
    constructor(audio) {
        super("Speed");
        this.width = 500;
        this.height = 800;
        this.speed;
        this.audio = audio;
        this.BackgroundUrl = 'images/wood.jpg';
        this.DeckSpriteSheet = 'images/Decks/SimpleDualSideDeck_SpriteSheet.png';
        this.DeckSpriteSheetJson = 'images/Decks/SimpleDualSideDeck_SpriteSheet.json';

        this.cardUIs = [];
        this.textblock;
        this.cardLayer;
        this.drawPile1;
        this.drawPile1a;
        this.drawPile2;
        this.drawPile2a;
        this.pullPile1;
        this.pullPile1a;
        this.pullPile2;
        this.pullPile2a;
        this.txtGameOverMessage;

        this.player2;
        this.playerPosition = "Bottom";
        this.hand1 = { x: 0, y: 515, zOrder: -1, width: 470 };
        this.hand2 = { x: 0, y: 180, zOrder: -1, width: 470 };


        this.layoutNormal = {
            textblock1: { x: 175, y: 130 },
            textblock2: { x: 30, y: 690 },
            drawPile1: { x: 337, y: 793 },
            drawPile1a: { x: 337 + 4, y: 793 + 4 },
            drawPile2: { x: 7, y: 170 },
            drawPile2a: { x: 7 + 4, y: 170 + 4 },
            hand1: { x: 0, y: 515, zOrder: -1, width: 470 },
            hand2: { x: 0, y: 180, zOrder: -1, width: 470 },
            blockHandBox1: { x: 0, y: 515, height: 155, width: 500 },
            blockHandBox2: { x: 0, y: 180, height: 155, width: 500 },
            hs1: { x: 140, y: 350 },
            hs2: { x: 260, y: 350 },
            pullPile1a: { x: 15 + 5, y: 345 + 5 },
            pullPile1: { x: 15, y: 345 },
            pullPile2a: { x: 380 + 5, y: 345 + 5 },
            pullPile2: { x: 380, y: 345 },
            buttonExit: { x: 5, y: 5, w: 50, h: 50 },
            styleProfile: { font: "24px Arial", fill: "#ffffff", align: "center" },
            styleProfileSmall: { font: "14px Arial", fill: "#ffffff", align: "center" },
            profile1Background: { x: 175, y: 60, width: 250, height: 60 },
            imgProfile1: { x: 175 + 5, y: 60 + 5, width: 50, height: 50 },
            txtProfile1: { x: 175 + 5 + +50 + 10, y: 60 + 5 },
            txtProfile1Rank: { x: 175 + 5 + 50 + 10, y: 60 + 36 },
            profile2Background: { x: 80, y: 730, width: 250, height: 60 },
            imgProfile2: { x: 80 + 5, y: 730 + 5, width: 50, height: 50 },
            txtProfile2: { x: 80 + 5 + 50 + 10, y: 730 + 5, },
            txtProfile2Rank: { x: 80 + 5 + 50 + 10, y: 730 + 36 },
            btnReady: { x: 135, y: 400}
        };
        this.layoutFliped = {
            textblock1: { x: 30, y: 690 },
            textblock2: { x: 175, y: 130 },
            drawPile2: { x: 337, y: 793 },
            drawPile2a: { x: 337 + 4, y: 793 + 4 },
            drawPile1: { x: 7, y: 170 },
            drawPile1a: { x: 7 + 4, y: 170 + 4 },
            hand1: { x: 0, y: 180, zOrder: -1, width: 470 },
            hand2: { x: 0, y: 515, zOrder: 1, width: 470 },
            blockHandBox1: { x: 0, y: 180, height: 155, width: 500 },
            blockHandBox2: { x: 0, y: 515, height: 155, width: 500 },
            hs2: { x: 140, y: 350 },
            hs1: { x: 260, y: 350 },
            pullPile2a: { x: 15 + 5, y: 345 + 5 },
            pullPile2: { x: 15, y: 345 },
            pullPile1a: { x: 380 + 5, y: 345 + 5 },
            pullPile1: { x: 380, y: 345 },
            buttonExit: { x: 5, y: 5, w: 50, h: 50 },
            styleProfile: { font: "24px Arial", fill: "#ffffff", align: "center" },
            styleProfileSmall: { font: "14px Arial", fill: "#ffffff", align: "center" },
            profile2Background: { x: 175, y: 60, width: 250, height: 60 },
            imgProfile2: { x: 175 + 5, y: 60 + 5, width: 50, height: 50 },
            txtProfile2: { x: 175 + 5 + +50 + 10, y: 60 + 5 },
            txtProfile2Rank: { x: 175 + 5 + 50 + 10, y: 60 + 36 },
            profile1Background: { x: 80, y: 730, width: 250, height: 60 },
            imgProfile1: { x: 80 + 5, y: 730 + 5, width: 50, height: 50 },
            txtProfile1: { x: 80 + 5 + 50 + 10, y: 730 + 5, },
            txtProfile1Rank: { x: 80 + 5 + 50 + 10, y: 730 + 36 },
            btnReady: { x: 135, y: 400}

        };
        this.layout = this.layoutNormal;


    }
    applyLayout(layout, source) {
        //apply layout / trasformation
        for (var layout_prop in layout) {
            if (layout.hasOwnProperty(layout_prop)) {
                for (var source_prop in source) {
                    if (layout_prop == source_prop) {
                        for (var layout_prop_prop in layout[layout_prop]) {
                            source[source_prop][layout_prop_prop] = layout[layout_prop][layout_prop_prop];
                        }
                    }
                }
            }
        }
    };
    init(data) {
        console.log("Scene Speed - init");
        if (this.speed) {
            this.speed.destroy();
        }
        this.speed = data.speed;
        if (data.deck) {
            this.DeckSpriteSheet = `images/Decks/${data.deck}_SpriteSheet.png`;
            this.DeckSpriteSheetJson = `images/Decks/${data.deck}_SpriteSheet.json`;
        }
        if (data.background) {
            this.BackgroundUrl = data.background;
        }

        this.scale.removeListener('resize', this.resize, this);
        this.scale.on('resize', this.resize, this);
    }
    resize(gameSize, baseSize, displaySize, previousWidth, previousHeight) {
        if (this.cameras && this.cameras.main && this.game && this.game.scale) {
            const camera = this.cameras.main;
            const gameWidth = this.game.scale.width;
            const gameHeight = this.game.scale.height;
            const sceneWidth = this.width; //this.sys.game.config.width;
            const sceneHeight = this.height; //this.sys.game.config.height;
            const scaleX = gameWidth / sceneWidth;
            const scaleY = gameHeight / sceneHeight;
            const ration = Math.min(scaleX, scaleY);
            camera.setZoom(ration);
            camera.centerOn(sceneWidth / 2, sceneHeight / 2)

            console.log('resize');
        }
    };
    // loadRender() {
    //     this.game.debug.text('Loading ...' + this.game.load.progress, 180, 200);
    // },
    preload() {
        //this.game.renderlock = false;
        //this.scale.refresh();
        //this.load.crossOrigin = 'anonymous';
        this.textures.remove('cards');
        this.load.atlas('cards', this.DeckSpriteSheet, this.DeckSpriteSheetJson);
        this.load.image('Background', this.BackgroundUrl);
        this.load.image('GameOverBackground', 'images/GameOverBackground.png');
        this.load.image('ButtonBlankShadow', 'images/ButtonBlankShadow.png');
        this.load.image('BackButton', 'images/BackButton.png');
        this.load.image('ProfileDefault', 'images/Avatars/default-avatar.png');
        this.load.image('fire_particle', 'images/Particles/fire_01.png');

        // this.load.audio('swish', 'audio/swish.mp3');
        // this.load.audio('swish2', 'audio/swish.wav');
        // this.load.audio('bump', 'audio/bump.wav');
        // this.load.audio('shuffle', 'audio/shuffle.wav');
        // this.load.audio('flipcard', 'audio/flipcard.wav');
        // this.load.audio('win', 'audio/chime.wav');


        //this.scale.setGameSize(300, 300);
    }
    create(data) {
        this.events.on('pause', function () {
            console.log('Scene paused');
        })

        this.events.on('resume', function () {
            console.log('Scene resumed');
        })
        this.cardUIs = [];

        //create new if needed, so it can be preset if need
        if (!this.speed) this.speed = new Speed();
        //moved out of the UI
        //this.speed.player2 = this.player2;

        //todo: maybe remove and have have a different trigger to start, such as in the controller
        // this.speed.setUpGame();

        ////add a few more touch points
        //this.game.input.addPointer();
        //this.game.input.addPointer();
        //this.game.input.addPointer();
        this.game.input.maxPointers = 2;
        if (this.speed.PlayerBottom.isLocal == true && this.speed.PlayerTop.isLocal == true) {
            this.game.input.maxPointers = -1;
            this.game.input.addPointer();
            this.game.input.addPointer();
            this.game.input.addPointer();
        }




        var _this = this;

        this.speed.onMessage = function (message, value, location, player) {
            _this.onEventMessage(message, value, location, player);
        };




        // //should switch timer to use game time not js timers, but the game logic knows nothing of the UI.
        // this.game.onPause.add(this.onGamePause, this);
        // this.game.onResume.add(this.onGameResume, this);

        //var key = _this.game.input.keyboard.addKey(Phaser.Keyboard.P); //see here: http://docs.phaser.io/Keyboard.js.html for the keycodes
        //key.onDown.add(function () {
        //    _this.speed.gameOver(_this.speed.PlayerTop, _this.speed.PlayerBottom)
        //});

        //add background
        var background = this.add.sprite(0, 0, 'Background');
        background.setOrigin(0, 0);
        background.displayWidth = this.width;
        background.displayHeight = this.height;
        background.x = 0;
        background.y = 0;



        //this.background = this.add.sprite(0, 0, 'cards', 'wood.jpg');
        // this.add.tileSprite(0, 0, 1000, 1000, 'cards', 'wood.jpg');

        this.textblock1 = this.add.text(100, 175, "", { font: "50px Arial", fill: "#ffffff", align: "center" });
        this.textblock1.setOrigin(0, 0);
        this.textblock1.setScale(0.5);
        this.textblock2 = this.add.text(30, 675, "", { font: "50px Arial", fill: "#ffffff", align: "center" });
        this.textblock2.setOrigin(0, 0);
        this.textblock2.setScale(0.5);


        //addhotspots
        this.hs1 = this.add.sprite(140, 315, 'cards', 'CardBack.png');
        this.hs1.displayWidth = 115;
        this.hs1.displayHeight = 160; //100x134
        this.hs1.alpha = 0;
        this.hs1.setOrigin(0, 0);
        this.hs2 = this.add.sprite(260, 315, 'cards', 'CardBack.png');
        this.hs2.displayWidth = 115;
        this.hs2.displayHeight = 160; //100x134
        this.hs2.alpha = 0;
        this.hs2.setOrigin(0, 0);


        ////addbuttons
        this.drawPile1a = this.add.sprite(345, 745, 'cards', 'CardBack.png');
        this.drawPile1a.angle = -90;
        this.drawPile1a.displayWidth = 115;
        this.drawPile1a.displayHeight = 160; //100x134
        this.drawPile1a.setOrigin(0, 0);
        this.drawPile1 = this.add.sprite(340, 740, 'cards', 'CardBack.png');
        this.drawPile1.displayWidth = 115;
        this.drawPile1.displayHeight = 160; //100x134
        this.drawPile1.setOrigin(0, 0);
        this.drawPile1.angle = -90;
        this.drawPile1.interactive = true;
        this.drawPile1.buttonMode = true;
        this.drawPile1.setInteractive();
        this.drawPile1.on('pointerdown', () => this.speed.FillHand1());


        this.drawPile2a = this.add.sprite(15, 115, 'cards', 'CardBack.png');
        this.drawPile2a.angle = -90;
        this.drawPile2a.displayWidth = 115;
        this.drawPile2a.displayHeight = 160; //100x134
        this.drawPile2a.setOrigin(0, 0);
        this.drawPile2 = this.add.sprite(10, 110, 'cards', 'CardBack.png');
        this.drawPile2.angle = -90;
        this.drawPile2.displayWidth = 115;
        this.drawPile2.displayHeight = 160; //100x134
        this.drawPile2.setOrigin(0, 0);
        this.drawPile2.interactive = true;
        this.drawPile2.buttonMode = true;
        this.drawPile2.setInteractive();
        this.drawPile2.on('pointerdown', () => this.speed.FillHand2());



        this.pullPile1a = this.add.sprite(20, 315, 'cards', 'CardBack.png');
        this.pullPile1a.setOrigin(0, 0);
        this.pullPile1a.displayWidth = 115;
        this.pullPile1a.displayHeight = 160; //100x134
        this.pullPile1 = this.add.sprite(15, 310, 'cards', 'CardBack.png');
        this.pullPile1.setOrigin(0, 0);
        this.pullPile1.displayWidth = 115;
        this.pullPile1.displayHeight = 160;
        this.pullPile1.interactive = true;
        this.pullPile1.buttonMode = true;
        this.pullPile1.setInteractive();
        this.pullPile1.on('pointerdown', () => this.speed.pull());

        this.pullPile2a = this.add.sprite(385, 315, 'cards', 'CardBack.png');
        this.pullPile2a.setOrigin(0, 0);
        this.pullPile2a.displayWidth = 115;
        this.pullPile2a.displayHeight = 160; //100x134
        this.pullPile2 = this.add.sprite(380, 310, 'cards', 'CardBack.png');
        this.pullPile2.setOrigin(0, 0);
        this.pullPile2.displayWidth = 115;
        this.pullPile2.displayHeight = 160; //100x134
        this.pullPile2.interactive = true;
        this.pullPile2.buttonMode = true;
        this.pullPile2.setInteractive();
        this.pullPile2.on('pointerdown', () => this.speed.pull());



        //add layer
        this.cardLayer = this.add.layer();
        this.cardLayer.setDepth(2);
        for (var i = 0; i < this.speed.cards.length; i++) {
            var cardId = this.speed.cards[i].id;
            var cardIdUI = this.speed.cards[i].ui;
            this.createCard(cardId, cardIdUI, this.cardLayer, 200, 300);
            // this.createCard(cardId, this.cardLayer, Math.random() * 500, Math.random() * 500);
        }
        // this.cardLayer.children.sort(this.depthCompare);
        this.cardLayer.sort();
        this.input.on('dragstart', this.startDrag, this);
        this.input.on('drag', this.drag, this);
        this.input.on('dragend', this.stopDrag, this);


        //add ready button 
        this.btnReady = new ButtonSolid(this, 135, 400, 'Ready', 0x479ACE, 250, 60);
        this.btnReady.on('pointerdown', () => {
            const player = this.speed.PlayerBottom.isLocal ? "Bottom" : "Top";
            this.speed.ready(player);
        });
        this.add.existing(this.btnReady);


        //add layer
        this.gameOverLayer = this.add.layer();
        this.gameOverLayer.x = 0;
        this.gameOverLayer.y = 0;
        this.gameOverLayer.setDepth(1000);

        this.gameOverBackground = this.add.sprite(0, 0, 'Background');
        //this.gameOverBackground = this.add.sprite(0, 0, 'GameOverBackground');
        this.gameOverBackground.displayWidth = this.width;
        this.gameOverBackground.displayHeight = this.height;
        this.gameOverBackground.setOrigin(0, 0);
        this.gameOverBackground.alpha = 1;
        // this.gameOverBackground.interactive = true;
        // this.gameOverBackground.buttonMode = true;
        // this.gameOverBackground.setInteractive();
        // this.gameOverBackground.on('pointerdown',this.quitGame,this);
        this.gameOverLayer.add(this.gameOverBackground);

        var style = { font: "100px Arial", fill: "#ffffff", align: "center" };
        this.txtGameOverMessage = this.add.text(this.width / 2, 200, "Game over", style);
        this.txtGameOverMessage.setOrigin(0.5, 0.5);
        this.txtGameOverMessage.setScale(0.5);
        this.gameOverLayer.add(this.txtGameOverMessage);


        var style = { font: "40px Arial", fill: "#ffffff", align: "center" };
        this.txtGameOverTime = this.add.text(this.width / 2, 250, "Time: 0", style);
        this.txtGameOverTime.setOrigin(0.5, 0.5);
        this.txtGameOverTime.setScale(0.5);
        this.gameOverLayer.add(this.txtGameOverTime);

        this.txtGameOverBlocks = this.add.text(this.width / 2, 290, "0", style);
        this.txtGameOverBlocks.setOrigin(0.5, 0.5);
        this.txtGameOverBlocks.setScale(0.5);
        this.gameOverLayer.add(this.txtGameOverBlocks);

        this.txtGameOverStreakMax = this.add.text(this.width / 2, 330, "0", style);
        this.txtGameOverStreakMax.setOrigin(0.5, 0.5);
        this.txtGameOverStreakMax.setScale(0.5);
        this.gameOverLayer.add(this.txtGameOverStreakMax);



        this.gameOverButton = this.add.sprite(this.width / 2, 500, 'ButtonBlankShadow');
        this.gameOverButton.setOrigin(0.5, 0.5);
        this.gameOverButton.displayWidth = 400;
        this.gameOverButton.setInteractive();
        this.gameOverButton.on('pointerdown', this.gameOverButtonClick, this);
        this.gameOverLayer.add(this.gameOverButton);


        var style = { font: "70px Arial", fill: "#ffffff", align: "center" };
        this.txtGameOverMessage2 = this.add.text(this.width / 2, 500, "Play again", style);
        this.txtGameOverMessage2.setOrigin(0.5, 0.5);
        this.txtGameOverMessage2.setScale(0.5);
        this.gameOverLayer.add(this.txtGameOverMessage2);

        this.gameOverLayer.visible = false;
        // this.add.tween(this.gameOverLayer).from({ alpha: 0 }, 2000, Phaser.Easing.Cubic.Out, true, false, false);



        //exit button
        this.buttonExit = this.add.sprite(435, 10, 'BackButton');
        this.buttonExit.setOrigin(0, 0);
        this.buttonExit.displayWidth = 50;
        this.buttonExit.displayHeight = 50;
        this.buttonExit.setInteractive();
        this.buttonExit.on('pointerdown', this.quitGame, this)


        this.styleProfile = { font: "44px Arial", fill: "#ffffff", align: "center" };
        this.styleProfileSmall = { font: "28px Arial", fill: "#ffffff", align: "center" };

        //setup profile image 1
        this.profile1Background = this.add.sprite(170, 10, 'ButtonBlankShadow');
        this.profile1Background.setOrigin(0, 0);
        this.profile1Background.displayWidth = 250;
        this.profile1Background.displayHeight = 60;
        this.profile1Background.alpha = 0.5;

        this.txtProfile1 = this.add.text(170 + 5 + +50 + 10, 15 + 2, "Top", this.styleProfile);
        this.txtProfile1.setOrigin(0, 0);
        this.txtProfile1.setScale(0.5);
        this.txtProfile1Rank = this.add.text(170 + 5 + +50 + 10, 15 + 33, "", this.styleProfileSmall);
        this.txtProfile1Rank.setOrigin(0, 0);
        this.txtProfile1Rank.setScale(0.5);
        this.imgProfile1 = this.add.sprite(170 + 5, 15, 'ProfileDefault');
        this.imgProfile1.setOrigin(0, 0);
        this.imgProfile1.displayWidth = 50;
        this.imgProfile1.displayHeight = 50;

        //setup profile image 2
        this.profile2Background = this.add.sprite(80, 680, 'ButtonBlankShadow');
        this.profile2Background.setOrigin(0, 0);
        this.profile2Background.displayWidth = 250;
        this.profile2Background.displayHeight = 60;
        this.profile2Background.alpha = 0.5;
        this.txtProfile2 = this.add.text(80 + 5 + 50 + 10, 685 + 2, "Buttom", this.styleProfile);
        this.txtProfile2.setOrigin(0, 0);
        this.txtProfile2.setScale(0.5);
        this.txtProfile2Rank = this.add.text(80 + 5 + +50 + 10, 685 + 33, "", this.styleProfileSmall);
        this.txtProfile2Rank.setOrigin(0, 0);
        this.txtProfile2Rank.setScale(0.5);
        this.imgProfile2 = this.add.sprite(80 + 5, 685, 'ProfileDefault');
        this.imgProfile2.setOrigin(0, 0);
        this.imgProfile2.displayWidth = 50;
        this.imgProfile2.displayHeight = 50;


        //block hand box
        this.blockHandBox1 = this.add.sprite(0, 465, 'ButtonBlankShadow');
        this.blockHandBox1.setOrigin(0, 0);
        this.blockHandBox1.displayWidth = 500;
        this.blockHandBox1.displayHeight = 155;
        this.blockHandBox1.alpha = 0.1;
        this.blockHandBox1.setInteractive();
        this.blockHandBox1.setDepth(3);
        this.blockHandBox1.visible = false;


        //block hand box 2
        this.blockHandBox2 = this.add.sprite(0, 130, 'ButtonBlankShadow');
        this.blockHandBox2.setOrigin(0, 0);
        this.blockHandBox2.displayWidth = 500;
        this.blockHandBox2.displayHeight = 155;
        this.blockHandBox2.alpha = 0.1;
        this.blockHandBox2.setInteractive();
        this.blockHandBox2.setDepth(3);
        this.blockHandBox2.visible = false;





        this.updateLayout();



        //todo:trigger ready as if a player loading and let controller start the game
        //this.speed.start();
        this.speed.message("ready", "UI", null, "Local");

        this.speed.message("loaded", "UI", null, "Local");

        
    }

    updateLayout() {
        if (this.speed.PlayerBottom.isLocal)
            this.applyLayout(this.layoutNormal, this);
        else
            this.applyLayout(this.layoutFliped, this);

        this.resize();
    }
    dynamicUpdateTexture(image, url, key, width, height) {

        if (!key) key = 'dynamicLoad_' + url;
        if (this.textures.exists(key)) {
            image.setTexture(key);
            if (width) image.displayWidth = width;
            if (height) image.displayHeight = height;
        }
        else {
            this.load.image(key, url);
            this.load.once(Loader.Events.COMPLETE, () => {
                image.setTexture(key);
                if (width) image.displayWidth = width;
                if (height) image.displayHeight = height;
            });
            this.load.start();
        }
    }
    update() {

        //auto drop
        for (let key in this.cardUIs) {
            var sprite = this.cardUIs[key];
            if (sprite.dragging !== true) continue;
            if (sprite.disableAutoDrop === undefined || sprite.disableAutoDrop === false) {
                if (this.hitTest(this.hs1, sprite)) {
                    var card = this.speed.getCard(sprite.cardId);
                    var canDrop = this.speed.canDrop(card, "hs1");
                    if (canDrop) {
                        var played = this.speed.tryPlayCard(card, "hs1");
                        if (played) {
                            sprite.input.enabled = false;  //'soft toggle
                            sprite.dragging = false;
                            //todo: remove
                            this.onEventMessage("cardMoved", "AutoDrop");
                        }
                    }
                }
                //check if hit hs2
                if (this.hitTest(this.hs2, sprite)) {
                    var card = this.speed.getCard(sprite.cardId);
                    var canDrop = this.speed.canDrop(card, "hs2");
                    if (canDrop) {
                        var played = this.speed.tryPlayCard(card, "hs2");
                        if (played) {
                            sprite.input.enabled = false; //'soft toggle
                            sprite.dragging = false;
                            //todo: remove
                            this.onEventMessage("cardMoved", "AutoDrop");
                        }
                    }
                }
            }
        }


    }
    gameOverButtonClick() {
        if (this.gameOverLayer.visible === true) {
            this.quitGame();
        }
    }
    quitGame(ponter) {
        //this.shutdown();
        //	Then let's go back to the main menu.
        try { window.history.back(); }
        catch (ex) { window.location.href = 'index.html'; }
    }
    createCard(id, imgId, cardLayer, x, y) {


        if (imgId.indexOf("11") === 0) imgId = imgId.replace("11", "J");
        if (imgId.indexOf("12") === 0) imgId = imgId.replace("12", "Q");
        if (imgId.indexOf("13") === 0) imgId = imgId.replace("13", "K");
        if (imgId.indexOf("10") != 0 && imgId.indexOf("1") === 0) imgId = imgId.replace("1", "A");

        //let cardUI = this.add.sprite(0, 0, 'cards', imgId.toUpperCase() + ".png");
        let cardUI = new CardUI(this, 0, 0, imgId);
        this.children.add(cardUI);
        //this.add.existing(cardUI);

        cardUI.cardId = id;
        cardUI.setOrigin(0, 0);
        this.cardUIs[id] = cardUI;



        // enable the bunny to be interactive.. this will allow it to respond to mouse and touch events
        cardUI.interactive = true;
        // this button mode will mean the hand cursor appears when you rollover the bunny with your mouse
        cardUI.buttonMode = true;

        // center the bunnys anchor point
        // cardUI.anchor.x = 0.5;
        // cardUI.anchor.y = 0.5;
        // make it a bit bigger, so its easier to touch
        //cardUI.scaleX = cardUI.scaleY = .5;
        cardUI.displayWidth = 115;
        cardUI.displayHeight = 160;
        // move the sprite to its designated position
        cardUI.x = x;
        cardUI.y = y;
        cardUI.setDepth(x);

        // cardUI.displayWidth =  115;
        //  cardUI.displayHeight =  154;
        cardUI.setInteractive({ draggable: true });
        this.input.setDraggable(cardUI);


        // cardUI.setInteractive();
        // cardUI.input.enableDrag(true, true);
        // // use the mousedown and touchstart
        // cardUI.events.onDragStart.add(this.startDrag, this);
        // cardUI.events.onDragStop.add(this.stopDrag, this);

        // add it to the stage
        cardLayer.add(cardUI);
    }
    startDrag(pointer, sender) {
        // if (this.speed.isHandDisabled("Player1")) {
        ////    //sender.input.draggable = false;
        ////    var card = this.speed.getCard(sender.cardId);
        ////    card.isDragable = false;
        ////    sender.input.enabled = false;
        // sender.input.disableDrag();
        // return;

        //}

        sender.dragging = true;
        if (sender.tween) {
            sender.tween.stop();
            sender.tweenx = 0;
            sender.tweeny = 0;
        }
        sender.zold = sender.z;
        sender.setDepth(1000);
        this.speed.message("startDrag", sender.cardId, null, "touch");
    }
    drag(pointer, gameObject, dragX, dragY) {
        if (gameObject.dragging === true) {
            gameObject.x = dragX;
            gameObject.y = dragY;
            //this.fire.setPosition(pointer.worldX, pointer.worldY);
        }
    }
    stopDrag(pointer, sender) {
        if (this.fire) this.fire.stop();
        sender.dragging = false;
        sender.setDepth(sender.zold);
        sender.tweenx = 0;//reset tween
        this.speed.message("stopDrag", sender.cardId)
        if (this.hitTest(this.hs1, sender)) {
            var card = this.speed.getCard(sender.cardId);
            if (card && card.pile !== "hs1")
                this.speed.tryPlayCard(card, "hs1");
        }
        //check if hit hs2
        if (this.hitTest(this.hs2, sender)) {
            var card = this.speed.getCard(sender.cardId);
            if (card && card.pile !== "hs2")
                this.speed.tryPlayCard(card, "hs2");
        }
    }
    hitTest(sprite1, sprite2) {
        if (sprite1.x + sprite1.displayWidth > sprite2.x) {
            if (sprite1.x < sprite2.x + sprite2.displayWidth) {
                if (sprite1.y + sprite1.displayHeight > sprite2.y) {
                    if (sprite1.y < sprite2.y + sprite2.displayHeight) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    populateGameOverScreen() {
        let totalTime = this.speed.elaspedTime;
        let totalSeconds = Math.round(totalTime * 100) / 100;
        //let minutes = Math.floor(totalTime / 60);
        //let seconds = Math.round((totalTime - minutes * 60) * 100) / 100;
        let winnerMsg = this.speed.winnerMsg;
        let coinsEarned = 0;

        let blockedCount = 0;
        let maxStreakCount = 0;
        if (this.speed.PlayerTop && this.speed.PlayerTop.isLocal) {
            blockedCount = this.speed.blockedCountTop;
            maxStreakCount = this.speed.maxStreakCountTop;
        } else {
            blockedCount = this.speed.blockedCountBottom;
            maxStreakCount = this.speed.maxStreakCountBottom;
        }

        this.txtGameOverMessage.text = winnerMsg;
        this.txtGameOverTime.text = "Time: " + totalSeconds;
        this.txtGameOverBlocks.text = "Blocks: " + blockedCount;
        this.txtGameOverStreakMax.text = "Max Streak: " + maxStreakCount;
    }
    onEventMessage(msg, value, location, player) {
        console.log(msg);
        if (this.stateUI !== this.speed.state) {
            this.stateUI = this.speed.state;
            if (this.stateUI == "PreGame") {
                this.gameOverLayer.visible = false;
                this.btnReady.visible = true;
            }
            if (this.stateUI == "Playing") {
                this.gameOverLayer.visible = false;
                this.btnReady.visible = false;
            }
            if (this.stateUI == "GameOver") {
                this.populateGameOverScreen();
                this.gameOverLayer.visible = true;
                this.btnReady.visible = false;
            }
        }
        //handle UI update reagardless of state or message
        if (msg == "ready") {
            const highlight = this.speed.PlayerBottom.isReady || this.speed.PlayerTop.isReady;
            this.btnReady.setHighlight(highlight);
        }


        if (msg == 'pause') {
            this.scene.pause();
        }
        if (msg == 'resume' || msg == 'start' || msg == 'resetGame') {
            this.scene.resume();
        }
        if (msg == 'start' || msg == 'resetGame') {
            for (var i = 0; i < this.speed.cards.length; i++) {
                card = this.speed.cards[i];
                var sprite = this.cardUIs[card.id];
                if (sprite) {
                    sprite.dragging = false;
                    sprite.disableAutoDrop = false;
                }
            }

        }
        if (msg == "gameover") {
            var tween = this.tweens.add({
                targets: this.gameOverLayer,
                alpha: { from: 0, to: 1 },
                ease: 'Linear',  // 'Cubic', 'Elastic', 'Bounce', 'Back'
                duration: 2000,
                repeat: 0,
                yoyo: false
            });
            if (this.audio)
                this.audio.play("win");
        }
        if (msg === "drop") {
            if (this.audio)
                this.audio.play("swish");
        }
        if (msg === "blocked") {
            if (this.audio)
                this.audio.play("bump");
        }
        if (msg === "fillHand") {
            if (this.audio)
                this.audio.play("flipcard");
        }
        if (msg === "pull") {
            if (this.audio)
                this.audio.play("swish2");
        }

        if (msg === "updateLayout" || msg === "start" || msg === "ready" || msg === "playerChanged" || msg === "setUpGame") {
            this.updateLayout();
        }

        //spanMessage.innerHTML = msg + " " + value;
        // if (this.textblock != undefined && msg =='message' ) this.textblock.text = msg;
        //todo: all card model properties should be set in the Speed core, such as isDragable, isFlipped, and isVisible.  Targetx is ui property
        var card = null;
        var gameWidth = 470;
        var pileCards = this.speed.getPile("hand1");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            // card.targetx = 10 + (i * 90);
            let maxHandWidthCount = 5;
            let width = this.hand1.width;
            let zOrder = this.hand1.zOrder;
            let handY = this.hand1.y;
            //todo: order right to left if fliped
            //todo: or dont move pile and just change name of pile
            // card.targetx = (10 * (1 + 5 - pileCards.length)) + (i * gameWidth / pileCards.length);
            if (zOrder == -1) card.targetx = (10 * (1 + 5 - Math.min(pileCards.length, maxHandWidthCount))) + ((Math.min(pileCards.length, maxHandWidthCount) - (i % maxHandWidthCount) - 1) * gameWidth / Math.min(pileCards.length, maxHandWidthCount));
            if (zOrder == 1) card.targetx = (10 * (1 + 5 - Math.min(pileCards.length, maxHandWidthCount))) + ((i % maxHandWidthCount) * width / Math.min(pileCards.length, maxHandWidthCount));

            card.targety = handY + (70 * Math.floor(i / maxHandWidthCount));

            if (card.selected === true && this.speed.showSelection) card.targety = handY - 15;
            card.targetz = -i + ((maxHandWidthCount * 2) * Math.floor(i / maxHandWidthCount));
            card.isDragable = true;
            card.isFlipped = false;
            card.isVisible = true;
            card.onFire = (this.speed.streakCountBottom >= 2);
        }
        var pileCards = this.speed.getPile("hand2");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            // card.targetx = 10 + (i * 90);
            let maxHandWidthCount = 5;
            let width = this.hand2.width;
            let zOrder = this.hand2.zOrder;
            let handY = this.hand2.y;
            //todo: order right to left if fliped
            if (zOrder == 1) card.targetx = (10 * (1 + 5 - Math.min(pileCards.length, maxHandWidthCount))) + ((Math.min(pileCards.length, maxHandWidthCount) - (i % maxHandWidthCount) - 1) * gameWidth / Math.min(pileCards.length, maxHandWidthCount));
            if (zOrder == -1) card.targetx = (10 * (1 + 5 - Math.min(pileCards.length, maxHandWidthCount))) + ((i % maxHandWidthCount) * width / Math.min(pileCards.length, maxHandWidthCount));

            card.targety = handY - (70 * Math.floor(i / maxHandWidthCount));;

            if (card.selected === true && this.speed.showSelection) card.targety = handY - 15 - (70 * Math.floor(i / maxHandWidthCount));
            // card.speed = 4;
            card.targetz = -i + ((maxHandWidthCount * 2) * Math.floor(i / maxHandWidthCount));
            card.isDragable = true;
            card.isFlipped = false;
            card.isVisible = true;
            card.onFire = (this.speed.streakCountTop >= 2);
        }
        var pileCards = this.speed.getPile("pull1");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.pullPile1.x + (i * 1);
            card.targety = this.pullPile1.y + (i * 1);
            card.targetz = i;
            card.isDragable = false;
            card.isFlipped = true;
            card.isVisible = false;
            this.pullPile1.visible = true;
            this.pullPile1a.visible = true;
        }
        if (pileCards.length == 0) {
            this.pullPile1.visible = false;
            this.pullPile1a.visible = false;
        }

        var pileCards = this.speed.getPile("pull2");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.pullPile2.x + (i * 1);
            card.targety = this.pullPile2.y + (i * 1);
            card.targetz = i;
            card.isDragable = false;
            card.isFlipped = true;
            card.isVisible = false;
            this.pullPile2.visible = true;
            this.pullPile2a.visible = true;
        }
        if (pileCards.length == 0) {
            this.pullPile2.visible = false;
            this.pullPile2a.visible = false;
        }
        var pileCards = this.speed.getPile("draw1");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.drawPile1.x + (i * 1);
            card.targety = this.drawPile1.y + (i * 1);
            card.targetz = i;
            card.isDragable = false;
            card.isFlipped = true;
            card.isVisible = false;
            this.drawPile1.visible = true;
            this.drawPile1a.visible = true;
        }
        if (pileCards.length == 0) {
            this.drawPile1.visible = false;
            this.drawPile1a.visible = false;
        }
        var pileCards = this.speed.getPile("draw2");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.drawPile2.x + (i * 1);
            card.targety = this.drawPile2.y + (i * 1);
            card.targetz = i;
            card.isDragable = false;
            card.isFlipped = true;
            card.isVisible = false;
            this.drawPile2.visible = true;
            this.drawPile2a.visible = true;
        }
        if (pileCards.length == 0) {
            this.drawPile2.visible = false;
            this.drawPile2a.visible = false;
        }

        var pileCards = this.speed.getPile("hs1");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.hs1.x;
            card.targety = this.hs1.y;
            card.targetz = i;
            //card.speed = 12;
            card.isDragable = false;
            card.isFlipped = false;
            card.isVisible = true;
            if (i < pileCards.length - 3) card.isVisible = false;
        }
        var pileCards = this.speed.getPile("hs2");
        for (var i = 0; i < pileCards.length; i++) {
            card = pileCards[i];
            card.targetx = this.hs2.x;
            card.targety = this.hs2.y;
            card.targetz = i;
            card.isDragable = false;
            card.isFlipped = false;
            card.isVisible = true;
            if (i < pileCards.length - 3) card.isVisible = false;
        }

        //todo: should do all this above and not set it on the model
        ////update UI
        for (var i = 0; i < this.speed.cards.length; i++) {
            card = this.speed.cards[i];
            // this.MoveElement(card.id, card.targetx, card.targety, card.targetz, card.fliped, card.isVisible, card.speed);
            var sprite = this.cardUIs[card.id];
            sprite.targetx = card.targetx;
            sprite.targety = card.targety;
            // sprite.z = card.targetz;
            sprite.targetz = card.targetz;
            sprite.speed = card.speed;
            sprite.visible = card.isVisible;
            sprite.pile = card.pile;
            sprite.onFire = card.onFire;
            var isLocalOwner = false;
            if (card.pile == 'hand2' && this.speed.PlayerTop.isLocal) {
                isLocalOwner = true;
            }
            if (card.pile == 'hand1' && this.speed.PlayerBottom.isLocal) {
                isLocalOwner = true;
            }
            if (sprite.input)
                sprite.input.enabled = card.isDragable && isLocalOwner;  //'soft toggle
            if (!card.isDragable)
                sprite.dragging = false;

            //sprite.disableAutoDrop = !card.isDragable;
        }

        if (msg === "StopMoveCardToPile") {
            var values = value.split(":");
            var moveCard = values[0];
            var sprite = this.cardUIs[moveCard];
            sprite.dragging = false;
            sprite.disableAutoDrop = false;
            if (sprite.tween) {
                sprite.tween.stop();
                sprite.tweenx = 0;
                sprite.tweeny = 0;
                sprite.tweenspeed = 0;
            }
        }
        if (msg === "moveCardToPile") {

            let values = value.split(":");
            let moveCard = values[0];
            let moveToPlie = values[1];
            let moveToSpeed = values[2];
            //tween card
            let sprite = this.cardUIs[moveCard];
            if (moveToPlie === "hs1") {
                sprite.tweenx = this.hs1.x;
                sprite.tweeny = this.hs1.y;
            }
            if (moveToPlie === "hs2") {
                sprite.tweenx = this.hs2.x;
                sprite.tweeny = this.hs2.y;
            }
            sprite.tweenspeed = Number(moveToSpeed);
            sprite.dragging = true;
            sprite.disableAutoDrop = true;
            sprite.zold = sprite.z;
            sprite.setDepth(1000);


            sprite.tween = this.tweens.add({
                targets: sprite,
                x: sprite.tweenx,
                y: sprite.tweeny,
                ease: 'Cubic.easeOut',
                duration: sprite.tweenspeed,
                onComplete: () => {
                    sprite.dragging = false;
                    sprite.disableAutoDrop = false;
                    this.onEventMessage("PostMoveCardToPile");
                },
                onCompleteScope: this
            });


        }

        for (let key in this.cardUIs) {
            var cardUI = this.cardUIs[key];
            cardUI.update();
        }

        //tween v2 - can be done on update msg
        for (let key in this.cardUIs) {

            var sprite = this.cardUIs[key];


            if (sprite.dragging === true) {
                continue;
            }
            //if (sprite.z !== sprite.targetz) sprite.z = sprite.targetz;
            if (sprite.depth !== sprite.targetz) sprite.setDepth(sprite.targetz);

            var moveSpeed = 250;
            if (sprite.tweenx != sprite.targetx || sprite.tweeny != sprite.targety || sprite.tweenspeed != moveSpeed) {
                if (sprite.tween) {
                    sprite.tween.stop();
                }
                sprite.tweenx = sprite.targetx || sprite.x;
                sprite.tweeny = sprite.targety || sprite.y;
                sprite.tweenspeed = moveSpeed || 250;



                sprite.tween = this.tweens.add({
                    targets: sprite,
                    x: sprite.tweenx,
                    y: sprite.tweeny,
                    ease: 'Cubic.easeOut',
                    duration: sprite.tweenspeed,
                });

            }

        }
        this.cardLayer.sort();
        //  this.cardLayer.children.sort(this.depthCompare);

        if (msg === "hint") {
            if (value === "pull") {
                //highlight pull piles
                this.tweens.add({
                    targets: [this.pullPile1, this.pullPile2],
                    alpha: 0,
                    ease: 'Linear',
                    duration: 250,
                    yoyo: true,
                    loop: 0
                });
                // var tween = this.add.tween(this.pullPile1).to({ alpha: 0 }, 250, Phaser.Easing.Linear.None, true, 0, 2, true);
                // var tween2 = this.add.tween(this.pullPile1).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 0, 1, false);
                // tween.chain(tween2);
                // var tween = this.add.tween(this.pullPile2).to({ alpha: 0 }, 250, Phaser.Easing.Linear.None, true, 0, 2, true);
                // var tween2 = this.add.tween(this.pullPile2).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 0, 1, false);
                // tween.chain(tween2);

            }
            else if (value === "hand1") {
                //highlight draw pile
                this.tweens.add({
                    targets: [this.drawPile1],
                    alpha: 0,
                    ease: 'Linear',
                    duration: 250,
                    yoyo: true,
                    loop: 0
                });
                // var tween = this.add.tween(this.drawPile1).to({ alpha: 0 }, 250, Phaser.Easing.Linear.None, true, 0, 2, true);
                // var tween2 = this.add.tween(this.drawPile1).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 0, 1, false);
                // tween.chain(tween2);
            }
            else {
                //highlight card
                this.tweens.add({
                    targets: [this.drawPile1],
                    alpha: 1 / 3,
                    ease: 'Linear',
                    duration: 250,
                    yoyo: true,
                    loop: 0
                });
                // var cardUI = this.cardUIs[value];
                // if (cardUI != undefined) {
                //     var tween = this.add.tween(cardUI).to({ alpha: 1 / 3 }, 250, Phaser.Easing.Linear.None, true, 0, 2, true);
                //     var tween2 = this.add.tween(cardUI).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 0, 1, false);
                //     tween.chain(tween2);
                // }
            }
        }
        if (msg === "blocked") {
        }
        if (msg === "combo") {
            if (player === "PlayerTop") {
                this.textblock1.text = value;
                this.textblock1.alpha = 1;
                this.tweens.add({
                    targets: [this.textblock1],
                    alpha: 0,
                    ease: 'Exponential.In',
                    duration: 3000
                });
                //var tween = this.add.tween(this.textblock1).to({ alpha: 0 }, 3000, Phaser.Easing.Exponential.In, true, false, 0, false);

            }
            if (player === "PlayerBottom") {
                this.textblock2.text = value;
                this.textblock2.alpha = 1;
                this.tweens.add({
                    targets: [this.textblock2],
                    alpha: 0,
                    ease: 'Exponential.In',
                    duration: 3000
                });
                //var tween = this.add.tween(this.textblock2).to({ alpha: 0 }, 3000, Phaser.Easing.Exponential.In, true, false, 0, false);

            }
        }
        if (msg === "disablehand") {
            var blockBox = null;
            if (value === "PlayerTop") {
                blockBox = this.blockHandBox2;
            }
            if (value === "PlayerBottom") {
                blockBox = this.blockHandBox1;
            }
            if (blockBox) {
                blockBox.visible = true;
                setTimeout(() => { blockBox.visible = false; }, 1000)
            }
        }
        // if (msg === "playerChanged") {
        if (this.speed.PlayerTop && this.speed.PlayerTop.name && this.txtProfile1.text !== this.speed.PlayerTop.name) {
            if (this.speed.PlayerTop.name !== undefined) this.txtProfile1.text = this.speed.PlayerTop.name || 'Player';
            if (this.speed.PlayerTop.rank !== undefined) this.txtProfile1Rank.text = this.speed.PlayerTop.rank || '';
            if (this.speed.PlayerTop.avatar)
                this.dynamicUpdateTexture(this.imgProfile1, this.speed.PlayerTop.avatar, null, 50, 50);
            else
                this.imgProfile1.setTexture("ProfileDefault");

        }
        if (this.speed.PlayerBottom && this.speed.PlayerBottom.name && this.txtProfile2.text !== this.speed.PlayerBottom.name) {
            if (this.speed.PlayerBottom.name !== undefined) this.txtProfile2.text = this.speed.PlayerBottom.name || 'Player';
            if (this.speed.PlayerBottom.rank !== undefined) this.txtProfile2Rank.text = this.speed.PlayerBottom.rank || '';
            if (this.speed.PlayerBottom.avatar)
                this.dynamicUpdateTexture(this.imgProfile2, this.speed.PlayerBottom.avatar, null, 50, 50);
            else
                this.imgProfile2.setTexture("ProfileDefault");
        }


    }
}